import { IPromise } from "angular";
import { MaintenanceHistory } from "../../entities/MaintenanceHistory";
import { MaintenanceHistoryService } from "../../services/MaintenanceHistoryService";
import { NotificationService } from "../../services/NotificationService";
import { IEditMaintenanceHandler } from "./IEditMaintenanceHandler";

export class EditMaintenanceHandler_NewAsset implements IEditMaintenanceHandler {
    
    editedMaintenaceHistories: MaintenanceHistory[] = [];
    addedMaintenaceHistories: MaintenanceHistory[] = [];
    deletedMaintenanceHistories: MaintenanceHistory[] = [];

    static $inject = ['$q', 'MaintenanceHistoryService', 'NotificationService'];

    constructor(public $q: ng.IQService, public mhService: MaintenanceHistoryService, public notifyService: NotificationService) {

    }

    deleteMaintenance(item: MaintenanceHistory): IPromise<boolean> {
        var index = this.addedMaintenaceHistories.indexOf(item);
        if (index != -1)
            this.addedMaintenaceHistories.splice(index, 1);
        else
            this.deletedMaintenanceHistories.push(item);
        var editedIndex = this.editedMaintenaceHistories.indexOf(item);
        if (editedIndex != -1)
            this.editedMaintenaceHistories.splice(editedIndex, 1);
        return this.$q.when<boolean>(true);
    }
    addMaintenance(entity: MaintenanceHistory): IPromise<boolean> {
        this.addedMaintenaceHistories.push(entity);
        return this.$q.when<boolean>(true);
    }
    editMaintenance(item: MaintenanceHistory): IPromise<boolean> {
        if (this.addedMaintenaceHistories.indexOf(item) == -1 && this.editedMaintenaceHistories.indexOf(item) == -1)
            this.editedMaintenaceHistories.push(item);
        return this.$q.when<boolean>(true);
    }
    saveData(entityId: number): IPromise<boolean> {
        var otherPromises: ng.IPromise<any>[] = [];
        $.each(this.editedMaintenaceHistories, (i, val) => {
            otherPromises.push(this.mhService.update(val));
        });
        $.each(this.addedMaintenaceHistories, (i, val) => {
            val.assetID = entityId;
            otherPromises.push(this.mhService.insert(val));
        });
        if (this.deletedMaintenanceHistories.length > 0) {
            var ids = $.map<MaintenanceHistory, number>(this.deletedMaintenanceHistories, (item, index) => item.id);
            otherPromises.push(this.mhService.delete(ids));
        }
        return this.$q.all(otherPromises)
            .then((data) => {
                return this.$q.when<boolean>(true);
            })
            .catch((err: any) => {
                return this.$q.reject("Got error in saving asset data:" + err);
            });
    }   
}
